import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PageService } from '../page.service';
import { DedaloService } from '../dedalo.service';
import { Entrevista } from '../entrevista';
import { PageItem } from '../page';
import { ActivatedRoute,Router, NavigationEnd } from "@angular/router";
import { SafeResourceUrl, DomSanitizer,SafeUrl } from '@angular/platform-browser';
import {
  AccessibilityConfig,
  Action,
  AdvancedLayout,
  ButtonEvent,
  ButtonsConfig,
  ButtonsStrategy,
  ButtonType,
  Description,
  DescriptionStrategy,
  DotsConfig,
  GalleryService,
  GridLayout,
  Image,
  ImageModalEvent,
  LineLayout,
  PlainGalleryConfig,
  PlainGalleryStrategy,
  PreviewConfig
} from '@ks89/angular-modal-gallery';

import * as $ from 'jquery';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnInit {

  pages : PageItem[] = []
  entrevistas : Entrevista[]
  slug : string;
  parent : string;
  imageIndex = 1;
  galleryId = 1;
  gallery: Image[];
  loaderPDF: number;

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    private galleryService: GalleryService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private entrevistaService : DedaloService
  ){
        this.route.params.subscribe( params => {
          this.slug = params.id;
          this.parent = params.parent
          this.getPage()
          // this.getEntrevistas()
        } );
  }

  ngOnInit() {
    // $('html body').animate(
    //   {scrollTop:0}, 1000);
    document.documentElement.scrollTop = 0
    this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });
  }

  get diagnosticEntrevistas() {
    return JSON.stringify(this.entrevistas)
  }

  // getEntrevistas() {
  //   this.entrevistaService.getInterviews()
  //   .subscribe(data => {
  //     this.entrevistas = data.result
  //   })
  // }

  getPage() {
    // console.log(this.slug);
    this.pageService.getPage(this.slug)
      .subscribe(data => {
        this.pages = data;
        this.pages.forEach( (p) => {
          this.pageService.currentPage = p as PageItem;
          // var safeUrl:SafeUrl;
          // safeUrl = this.sanitizer.bypassSecurityTrustUrl('https://backend.industriapaisaia.eus/wp-content/uploads/2018/10/test.pdf');
          // p['publitas_link_sanitize'] = safeUrl;
          // if (p['pdf']) { p['pdfUrl'] = p['pdf']['url'];  };
        })
      });
  }

  /** gallery **/
customPlainGalleryRowDescConfig: PlainGalleryConfig = {
  // strategy: PlainGalleryStrategy.CUSTOM,
  strategy: PlainGalleryStrategy.GRID,
  layout: new GridLayout({ width: '32%', height: 'auto' }, { length: 2, wrap: true })
  // layout: new AdvancedLayout(-1, true)

};

buttonsConfigSimple: ButtonsConfig = {
    visible: true,
    strategy: ButtonsStrategy.SIMPLE
};

buttonsConfigIndustria: ButtonsConfig = {
  visible:true,
  strategy: ButtonsStrategy.CUSTOM,
  buttons: [
    {
      className: 'download-image',
      type: ButtonType.DOWNLOAD,
      extUrlInNewTab: true
    },
    {
      className: 'fullscreen-image',
      type: ButtonType.FULLSCREEN
    },
    {
      className: 'close-image',
      type: ButtonType.CLOSE
    }
  ]
}

// onButtonBeforeHook(event: ButtonEvent) {
//     if (!event || !event.button) {
//       return;
//     }
//     if (event.button.type === ButtonType.DELETE) {
//       this.images = this.images.filter((val: Image) => event.image && val.id !== event.image.id);
//     }
//   }
//
//   onButtonAfterHook(event: ButtonEvent) {
//     if (!event || !event.button) {
//       return;
//     }
//   }

  onVisibleIndex(event: ImageModalEvent) {
    // console.log('onVisibleIndex action: ' + Action[event.action]);
    // console.log('onVisibleIndex result:' + event.result);
  }

openImageModalRowDescription(image: Image) {
  // console.log('Opening modal gallery from custom plain gallery row and description, with image: ', image);
  const index: number = this.getCurrentIndexCustomLayout(image, this.pages[0].gallery);
  this.customPlainGalleryRowDescConfig = Object.assign({}, this.customPlainGalleryRowDescConfig, { layout: new AdvancedLayout(index, true) });
}

private getCurrentIndexCustomLayout(image: Image, images: Image[]): number {
  return image ? images.indexOf(image) : -1;
}

onProgressPDF(event,total) {
  let loadInt = parseInt(event.loaded, 10);
  let totalInt = parseInt(total,10);
  this.loaderPDF = Math.floor(loadInt/totalInt*100);
}

windowOpen(url){
  window.open(url);
}

}
